import type { ICheckoutStep } from '@features/purchasing/types';
import type { HTMLProps, PropsWithChildren } from 'react';
import React from 'react';

interface IProps {
  steps: ICheckoutStep[];
}

function LocalAnchor({
  url,
  children,
  ...props
}: PropsWithChildren<{ url?: string }> & HTMLProps<HTMLAnchorElement | HTMLSpanElement>) {
  if (url) {
    return (
      <a href={url} {...(props as HTMLProps<HTMLAnchorElement>)}>
        {children}
      </a>
    );
  }

  return <span {...props}>{children}</span>;
}

export default function CheckoutBreadcrumbs(props: IProps) {
  return (
    <div className="tablet:mb-4">
      <div className="hidden tablet:flex flex-row gap-2 py-4">
        {props.steps.map((step, idx) => (
          <div
            key={step.url}
            className={`flex flex-auto items-center justify-center py-2 px-4 ${
              step.isCurrent ? 'bg-accent-dark text-white' : ''
            }`}>
            <LocalAnchor
              url={step.isCurrent ? step.url : undefined}
              className={`w-full flex items-center justify-center relative ${
                step.isCurrent ? 'font-semibold' : ''
              }`}>
              <span>
                {idx + 1}. {step.title}
              </span>
              {idx + 1 < props.steps.length && (
                <span className="icon absolute right-0">
                  <i className="fa-solid fa-chevron-right" />
                </span>
              )}
            </LocalAnchor>
          </div>
        ))}
      </div>
    </div>
  );
}
